export enum InternalTransferTab {
  Active = 'active',
  Archived = 'archived',
}
